// @ts-nocheck
// FIXME: typescript errors

import React from 'react';
import { darken } from 'polished';
import styled, { keyframes, css } from 'styled-components';
import Status from '../types/enum/Status';

type StyledIconProps = {
  size?: number;
  fixedWidth?: boolean;
  mr?: number;
  ml?: number;
  rotate?: number;
  color?: string;
  status?: Status;
  spin?: boolean;
  style?: {};
};

const spinAnim = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const StyledIcon = styled.i<StyledIconProps>`
  display: inline-flex;
  vertical-align: unset;
  ${({ fixedWidth }) =>
    fixedWidth &&
    css`
      text-align: left;
      width: 25px;
      height: 25px;
    `}

  font-size: ${({ theme, size }) =>
    theme.spacing.base * (size || 3.125)}px !important;

  margin-right: ${({ theme, mr }) => theme.spacing.base * (mr || 0)}px;
  margin-left: ${({ theme, ml }) => theme.spacing.base * (ml || 0)}px;
  text-decoration: none !important;

  ${({ rotate }) =>
    rotate &&
    css`
      transform: rotate(${rotate}deg);
    `}

  ${({ theme, status, color }) =>
    (color || status) &&
    css`
      color: ${color || theme.color.white};
    `}

  ${({ spin }) =>
    spin &&
    css`
      animation: ${spinAnim} 1s linear infinite;
    `} /* &:hover {
    text-decoration: none !important;
  } */
`;

type Props = {
  name: string;
} & StyledIconProps;

const Icon = ({
  name = 'circle',
  size,
  fixedWidth = true,
  ml,
  mr,
  status,
  rotate,
  color,
  spin,
  style,
  ...props
}: Props): JSX.Element => (
  <StyledIcon
    // data-feather={name}
    className={`uil uil-${name}`}
    fixedWidth={fixedWidth}
    size={size}
    mr={mr}
    ml={ml}
    rotate={rotate}
    color={color}
    status={status}
    spin={spin}
    style={style}
    {...props}
  />
);

Icon.defaulltProps = {
  size: 2,
};

const StyledClickableIcon = styled.button`
  background: none;
  border: none;
  padding: ${({ theme }) => theme.spacing.xs};
  margin: -${({ theme }) => theme.spacing.xs};
  display: inline-flex;

  outline: none;
  cursor: pointer;
  color: ${({ theme }) => theme.color.white};

  margin-right: calc(
    -${({ theme }) => theme.spacing.xs} + ${({ theme, mr }) => theme.spacing.base * (mr || 0)}px
  );
  margin-left: calc(
    -${({ theme }) => theme.spacing.xs} + ${({ theme, ml }) => theme.spacing.base * (ml || 0)}px
  );

  &:focus-visible {
    outline: 2px #000 solid;
    outline-style: auto;
  }
`;

export type ClickableIconProps = {
  style?: unknown;
  title?: string;
  onClick: (arg0: Event) => void;
} & Props;

export const ClickableIcon = ({
  ml,
  mr,
  title,
  onClick,
  style,
  ...props
}: ClickableIconProps): JSX.Element => (
  <StyledClickableIcon onClick={onClick} mr={mr} ml={ml} style={style}>
    <Icon {...props} />
    {title}
  </StyledClickableIcon>
);

ClickableIcon.defaulltProps = {
  title: '',
};

export default Icon;
